import withHandleRegularBooking, {
  type WithRegularBookingProps,
} from '@/components/hocs/withRegularBooking';
import RegularAvailabilitySlot, {
  type RegularAvailabilitySlotProps as Props,
} from '@discover-components/availability/regular/slot';

export type RegularAvailabilitySlotProps = Omit<
  Props,
  'handleBooking' | 'isProcessing' | 'selectedTime' | 'setSelectedTime'
> & {
  restaurant: Omit<WithRegularBookingProps['restaurant'], 'showBookingPriceLabel'>;
};

const RegularAvailabilitySlotWithBooking = (props: RegularAvailabilitySlotProps) =>
  withHandleRegularBooking(RegularAvailabilitySlot)({
    ...props,
    restaurant: {
      ...props.restaurant,
      showBookingPriceLabel: false,
    },
  });

export default RegularAvailabilitySlotWithBooking;
